export default __webpack_public_path__ + "static/media/logo.281fa58d.svg";